import { Outlet, createRootRoute, useRouterState } from "@tanstack/react-router";
import { AnimatePresence } from "motion/react";
import * as m from "motion/react-m";
import { OfflineBanner } from "@/features/offline-status/offline-status.ui";
import { PwaUpdateBanner } from "@/features/pwa-update/pwa-update.ui";
import { TooltipProvider } from "@/shared/ui/tooltip";

const RootComponent = () => {
  const pathname = useRouterState({ select: (s) => s.location.pathname });

  return (
    <TooltipProvider>
      <AnimatePresence mode="wait">
        <m.div
          key={pathname}
          className="h-screen w-screen"
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          exit={{ opacity: 0 }}
          transition={{ duration: 0.2, ease: "easeInOut" }}
        >
          <Outlet />
        </m.div>
      </AnimatePresence>
      <OfflineBanner />
      <PwaUpdateBanner />
    </TooltipProvider>
  );
};

export const Route = createRootRoute({
  component: RootComponent,
});
